<template>
  <div class="main-collection-cards critical-component-clear">
    <ul
      ref="collectionsCardsList"
      class="main-collection-cards__grid dormify-collection-chip__grid"
    >
      <DormifyCollectionChip
        v-for="(block, index) in blocks"
        :key="`main-collection-card-${index}-${liquid.sectionId}`"
        :block-class="'main-collection-cards'"
        :title="block.title"
        :label="block.label"
        :image-src="block.src"
        :url="block.url"
        :alt="block.alt"
        :is-active="index === isActiveIndex"
        context="plp"
        @click="handleActiveState(index);"
      />
    </ul>
  </div>
</template>

<script>

/**
 * Main collection cards (main-collection-cards)
 * -----------------------------------------------------------------------------
 * Section for collection category quicklink cards.
 *
 * @param {String} liquid.sectionId - Section's Liquid ID.
 *
 */
import breakpoint from '~/config/breakpoints'
import DormifyCollectionChip from '~async/dormify-collection-chip/dormify-collection-chip'

export default {
  name: 'MainCollectionCards',

  components: {
    DormifyCollectionChip,
  },

  props: {
    liquid: {
      type: Object,
      default: () => ({
        sectionId: '',
        initalActiveIndex: '',
        mobileCardWidth: '',
      }),
    },
    blocks: {
      type: Array,
      default: () => ([]),
    },
  },

  data() {
    return {
      isActiveIndex: '',
    }
  },

  mounted() {
    this.isActiveIndex = this.liquid.initalActiveIndex
    this.updateMobileCardPosition()
  },

  methods: {

    /**
     * Set the active state on click
     * @param {Number} index - from card
     */
    handleActiveState(index) {
      this.isActiveIndex = index
    },

    /**
     * Updates the default card scroll position on mobile
     */
    updateMobileCardPosition() {
      if (window.matchMedia(`(max-width: ${breakpoint.m})`).matches) {
        const cardList = this.$refs.collectionsCardsList
        const offsetValue = this.isActiveIndex * this.liquid.mobileCardWidth
        cardList.scrollLeft = offsetValue
      }
    },
  },
}
</script>

<style lang="scss">
@import './main-collection-cards';
</style>
